import hasDistributionList from './utilities/hasDistributionList';

const notification = (notificationJson) => {
  const properties = {
    ...notificationJson.attributes,
    guid: notificationJson.guid,
  };
  return Object.assign(
    hasDistributionList(notificationJson.attributes.distribution),
    properties,
  );
};

export default notification;
